import { render, staticRenderFns } from "./recaptcha.vue?vue&type=template&id=0b16e825"
import script from "./recaptcha.vue?vue&type=script&lang=js"
export * from "./recaptcha.vue?vue&type=script&lang=js"
import style0 from "./recaptcha.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/recaptcha/recaptcha.vue
// module id = eKuh
// module chunks = 0